/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * TAF Delivery API
 * OpenAPI spec version: 1.0
 */

export type AccommodationBookingInformationPageContentModelContentType = typeof AccommodationBookingInformationPageContentModelContentType[keyof typeof AccommodationBookingInformationPageContentModelContentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AccommodationBookingInformationPageContentModelContentType = {
  accommodationBookingInformationPage: 'accommodationBookingInformationPage',
} as const;
